import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import ExceptionHandler from './ExceptionHandler';
import Layout from './pages/Layouts';

import 'react-toastify/dist/ReactToastify.css';
import "./assets/css/style.module.css";

const Page = lazy(() => import('./pages/Page'));
const VersionCheck = lazy(() => import('./pages/Shared/VersionCheck'));

const SuspendPage = (element, fallback = <div />) => {
    return (
        <Suspense fallback={fallback}>
            {element}
        </Suspense>
    )
}

export default function App() {
	return (
        <BrowserRouter>
            <ExceptionHandler>
            <VersionCheck />
            <Routes>
                <Route element={<Layout />}>
                    <Route path="/reset-password/:hash" element={SuspendPage(<Page />)} />
                    <Route path="/article/:url" element={SuspendPage(<Page />)} />
                    <Route path="/category/:url" element={SuspendPage(<Page />)} />
                    <Route path="/theme/:url" element={SuspendPage(<Page />)} />
                    <Route path="/series/:url" element={SuspendPage(<Page />)} />
                    <Route path="/tag/:url" element={SuspendPage(<Page />)} />
                    <Route path="/register/:plan" element={SuspendPage(<Page />)} />
                    <Route path="/redeem/:hash" element={SuspendPage(<Page />)} />
                    <Route path="/reactivation/:hash" element={SuspendPage(<Page />)} />
                    <Route path="*" element={SuspendPage(<Page />)} />
                </Route>
            </Routes>
            <ToastContainer />
            </ExceptionHandler>
        </BrowserRouter>
	)
}